import Main from "./Main.js";
import Scene from "./Scene.js";
export default class WinfoImage {

	constructor(hs, parms, callback) {
		this.hs = hs;
		this.parms = parms;
		this.callback = callback;
	}

	init() {
		Main.debugTrace("Hotspot Winfoimage: " + this.hs.name);
		console.log(this.hs);
		// apre il layer con l'iframe
		Main.sfoca(true);
		Main.showInterface(false);
		let mc = jQuery("#template-trix-infoimage").clone();
		mc.attr("id", "tgal" + WinfoImage.ENUM++);
		jQuery(".js-trix1010").append(mc);
		this.mc = mc;

		jQuery(".js-close-frame", mc).on("click", jQuery.proxy(this.closeFrame, this));

		let a = this.hs.InfoJson.iframe_url.split("|");
		console.log(this.hs.InfoJson.iframe_url.split("|"));
		jQuery(".js-image", mc).css("background-image", "url('" + a[0] + "')")
		jQuery(".js-desc-item", mc).html(a[1]);
		//Main.setUrl(Scene.getCurrentScene().name, this.hs.Uid, null)
	}

	closeFrame(e) {
		this.mc.remove();
		Main.showInterface(true);
		Main.sfoca(false);
		//Main.setUrl(Scene.getCurrentScene().name, null, null);
	}

}

WinfoImage.ENUM = 0;